export default __webpack_public_path__ + "static/media/Ripesh.04390910.png";